const canvas = document.createElement('canvas');
const canvas2dContext = canvas.getContext('2d');

// `Sample` here was intentional. It has 'S' and 'p", forcing
// both extremes of the font to be evaluated
export function getTextHeight(font, text = 'Sample', extraSpace = 0) {
  canvas2dContext.font = font;

  const { fontBoundingBoxAscent, fontBoundingBoxDescent } = canvas2dContext.measureText(text);
  return fontBoundingBoxAscent + fontBoundingBoxDescent + extraSpace;
}

export function getTextWidth(font, text = 'Sample') {
  canvas2dContext.font = font;

  return canvas2dContext.measureText(text).width;
}
